function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ServiceFactory from "../../service";
import account from "../../data/account";

// Content Hub Trash (CONTENT_HUB_TRASH_2026-10-01): a delete never destroys anything on the spot.
function svc(api) {
  const S = ServiceFactory.getType(api, "product");
  return new S();
}
async function safe(promise, fallback) {
  try {
    return (await promise) || fallback;
  } catch (e) {
    return fallback;
  }
}
function toast(msg) {
  const t = document.querySelector("paper-toast");
  if (t) t.show(msg);
}
export function isContentAdmin() {
  try {
    const g = (account.get() || {}).groups || [];
    return ["owner", "administrator", "root"].some(x => g.includes(x));
  } catch (e) {
    return false;
  }
}
const utc = d => new Date(/Z$|[+-]\d\d:\d\d$/.test(String(d)) ? d : String(d) + "Z");
const ago = d => {
  if (!d) return "";
  const ms = Date.now() - utc(d).getTime();
  const days = Math.floor(ms / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  return `${days} days ago`;
};
const daysLeft = d => {
  if (!d) return 30;
  return Math.max(0, 30 - Math.floor((Date.now() - utc(d).getTime()) / 86400000));
};

/** Confirm sheet: shown only when the asset is used somewhere; otherwise callers delete straight away. */
export class DeleteSheet extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      usage: undefined,
      busy: false
    });
    _defineProperty(this, "onKey", e => {
      if (e.key === "Escape" && !this.state.busy) this.props.onClose();
    });
    _defineProperty(this, "load", async () => {
      const u = await safe(svc(`/content/assets/${String(this.props.asset.id)}/usage`).getAsync(), null);
      // Only skip the sheet when the usage call answered and found nothing; if it failed, ask (never delete blind).
      this.setState({
        usage: u || {
          pieces: [],
          unknown: true
        }
      });
      if (u && !(u.pieces && u.pieces.length) && !this.props.alwaysAsk) this.go(false);
    });
    _defineProperty(this, "go", async replace => {
      const {
        asset,
        versionOnly
      } = this.props;
      this.setState({
        busy: true
      });
      try {
        const r = await svc(`/content/assets/${String(asset.id)}?${versionOnly ? "scope=version&" : ""}replaceWithLatest=${replace ? "true" : "false"}`).deleteAsync();
        toast(versionOnly ? `v${asset.version} moved to Trash.` : `Moved to Trash${r && r.deleted > 1 ? ` with ${r.deleted - 1} version${r.deleted - 1 === 1 ? "" : "s"}` : ""}. Restore within 30 days.`);
        if (this.props.onDone) this.props.onDone();
      } catch (e) {
        toast(e && e.message || "Could not delete.");
      } finally {
        this.setState({
          busy: false
        });
        this.props.onClose();
      }
    });
  }
  componentDidMount() {
    this.load();
    document.addEventListener("keydown", this.onKey);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKey);
  }
  render() {
    const {
      asset,
      versionOnly,
      onClose
    } = this.props;
    const {
      usage,
      busy
    } = this.state;
    if (usage === undefined) return null;
    const pieces = usage && usage.pieces || [];
    if (!pieces.length && !usage.unknown && !this.props.alwaysAsk) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: () => {
        if (!busy) onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-modal hub-trash-sheet",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Move ", versionOnly ? `v${asset.version}` : `"${asset.title || "this asset"}"`, " to Trash?"), /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        margin: "2px 0 0"
      }
    }, versionOnly ? "Only this version" : `Original${Number(asset.versionCount) > 0 ? ` plus ${asset.versionCount} version${Number(asset.versionCount) === 1 ? "" : "s"}` : ""}`, " \xB7 you can restore it for 30 days"), pieces.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-uses"
    }, /*#__PURE__*/React.createElement("b", null, "Used in ", pieces.length, " piece", pieces.length === 1 ? "" : "s"), pieces.slice(0, 6).map((p, i) => /*#__PURE__*/React.createElement("span", {
      key: i
    }, p.title || `Piece ${p.containerId}`, p.role ? ` · ${p.role}` : "")), pieces.length > 6 && /*#__PURE__*/React.createElement("span", null, "and ", pieces.length - 6, " more"), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: "4px 0 0"
      }
    }, "Published copies on Shopify and social stay as they are. Pieces that still reference this image would show a broken image until you replace it.")), /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-acts"
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-flat",
      disabled: busy,
      onClick: onClose
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      disabled: busy,
      onClick: () => this.go(false)
    }, pieces.length ? "Keep references and move to Trash" : "Move to Trash"), pieces.length > 0 && /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: busy,
      onClick: () => this.go(true)
    }, "Replace with latest version, then Trash"))));
  }
}

/** The Trash view: rows with who, when, days until purge, Restore and Delete forever. */
export class TrashList extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: undefined,
      admin: false,
      busy: {}
    });
    _defineProperty(this, "_alive", true);
    _defineProperty(this, "load", async () => {
      const {
        kind,
        q
      } = this.props;
      const d = await safe(svc(`/content/assets/trash?${kind ? `kind=${kind}&` : ""}${q ? `q=${encodeURIComponent(q)}&` : ""}$top=100`).getAsync(), {
        items: []
      });
      if (this._alive) this.setState({
        items: d && d.items || [],
        admin: !!(d && d.admin) || isContentAdmin()
      });
    });
    _defineProperty(this, "act", async (a, what) => {
      const id = String(a.id);
      this.setState({
        busy: {
          ...this.state.busy,
          [id]: what
        }
      });
      try {
        if (what === "restore") {
          await svc(`/content/assets/${id}/restore`).postAsync({});
          toast(`Restored${a.parentAssetId ? "" : a.familyCount ? ` with ${a.familyCount} version${a.familyCount === 1 ? "" : "s"}` : ""}.`);
        } else {
          await svc(`/content/assets/${id}/purge`).deleteAsync();
          toast("Deleted forever. Files are removed tonight.");
        }
        if (this.props.onChange) this.props.onChange();
        await this.load();
      } catch (e) {
        toast(e && e.message || "Could not do that.");
      } finally {
        if (this._alive) this.setState({
          busy: {
            ...this.state.busy,
            [id]: null
          }
        });
      }
    });
    _defineProperty(this, "empty", async () => {
      if (!this.state.items || !this.state.items.length) return;
      this.setState({
        busy: {
          ...this.state.busy,
          __all: "empty"
        }
      });
      try {
        await svc("/content/assets/trash/empty").postAsync({});
        toast("Trash emptied. Files are removed tonight.");
        if (this.props.onChange) this.props.onChange();
        await this.load();
      } catch (e) {
        toast(e && e.message || "Could not empty the trash.");
      } finally {
        if (this._alive) this.setState({
          busy: {
            ...this.state.busy,
            __all: null
          }
        });
      }
    });
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  componentDidUpdate(prev) {
    if (prev.kind !== this.props.kind || prev.q !== this.props.q) this.load();
  }
  render() {
    const {
      items,
      admin,
      busy
    } = this.state;
    if (items === undefined) return /*#__PURE__*/React.createElement("p", {
      className: "as-trash-note"
    }, "Opening the Trash\u2026");
    const kindName = a => a.kind === "video" ? "Video" : a.kind === "image" ? "Picture" : "Document";
    // a readable name: never a raw file link with its query string
    const nameOf = a => {
      const t = String(a.title || "").trim();
      const raw = !t || /[?&=]|^https?:\/\//i.test(t) || /^[\w-]{24,}\.(jpe?g|png|webp|gif|mp4|mov|webm)/i.test(t);
      return raw ? `Untitled ${kindName(a).toLowerCase()}` : t;
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "as-trash"
    }, /*#__PURE__*/React.createElement("div", {
      className: "as-trash-top"
    }, /*#__PURE__*/React.createElement("span", {
      className: "as-trash-note"
    }, "Files here are deleted for good 30 days after they were moved. Restore one to put it back where it was, with its versions."), admin && items.length > 0 && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "as-btn",
      disabled: !!busy.__all,
      onClick: this.empty
    }, busy.__all ? "Emptying…" : "Empty the Trash")), !items.length ? /*#__PURE__*/React.createElement("div", {
      className: "as-trash-empty"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      "aria-hidden": "true"
    }, "delete_outline"), /*#__PURE__*/React.createElement("b", null, "The Trash is empty"), /*#__PURE__*/React.createElement("span", null, "Files you move to the Trash wait here for 30 days.")) : /*#__PURE__*/React.createElement("div", {
      className: "as-trash-grid"
    }, items.map(a => {
      const id = String(a.id);
      const left = daysLeft(a.deletedDate);
      const pic = a.kind === "image" ? a.url : a.posterUrl;
      const extra = a.parentAssetId ? `version ${a.version} only` : Number(a.familyCount) > 0 ? `with ${a.familyCount} other version${Number(a.familyCount) === 1 ? "" : "s"}` : "";
      return /*#__PURE__*/React.createElement("div", {
        key: id,
        className: "as-trash-card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "as-trash-pic"
      }, pic ? /*#__PURE__*/React.createElement("img", {
        src: pic,
        alt: "",
        loading: "lazy",
        onError: e => {
          e.currentTarget.style.display = "none";
        }
      }) : null, /*#__PURE__*/React.createElement("span", {
        className: "material-icons ph",
        "aria-hidden": "true"
      }, a.kind === "video" ? "movie" : a.kind === "image" ? "image" : "description"), /*#__PURE__*/React.createElement("span", {
        className: "as-trash-left" + (left <= 3 ? " soon" : "")
      }, left, " day", left === 1 ? "" : "s", " left")), /*#__PURE__*/React.createElement("div", {
        className: "as-trash-body"
      }, /*#__PURE__*/React.createElement("b", {
        title: nameOf(a)
      }, nameOf(a)), /*#__PURE__*/React.createElement("span", null, kindName(a), extra ? ` · ${extra}` : "", Number(a.usedCount) > 0 ? ` · was in ${a.usedCount} piece${Number(a.usedCount) === 1 ? "" : "s"}` : ""), /*#__PURE__*/React.createElement("span", {
        className: "q"
      }, "Deleted ", ago(a.deletedDate), a.deletedBy ? ` by ${String(a.deletedBy).split("@")[0]}` : ""), /*#__PURE__*/React.createElement("div", {
        className: "as-trash-acts"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-btn",
        disabled: !!busy[id],
        onClick: () => this.act(a, "restore")
      }, busy[id] === "restore" ? "Restoring…" : "Restore"), admin && (this.state.ask === id ? /*#__PURE__*/React.createElement("span", {
        className: "as-trash-ask"
      }, /*#__PURE__*/React.createElement("span", null, "Delete for good?"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-link danger",
        disabled: !!busy[id],
        onClick: () => {
          this.setState({
            ask: null
          });
          this.act(a, "purge");
        }
      }, busy[id] === "purge" ? "Deleting…" : "Delete"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-link",
        onClick: () => this.setState({
          ask: null
        })
      }, "Keep")) : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "as-link danger",
        disabled: !!busy[id],
        onClick: () => this.setState({
          ask: id
        })
      }, busy[id] === "purge" ? "Deleting…" : "Delete forever")))));
    })));
  }
}